/* eslint-disable react/prop-types */
import React from 'react'

import { formatNumber } from '../../utils'

function formatCondition(condition, originalCondition, unitSet, curves) {
    const {
        channel: mnemonic,
        comparator: comparatorRaw,
        threshold: convertedThreshold,
        rangeThreshold: convertedRangeThreshold,
        value: convertedValue,
        uom: convertedUom
    } = condition
    const {
        threshold: originalThreshold,
        rangeThreshold: originalRangeThreshold,
        value: originalValue,
        uom: originalUom
    } = originalCondition

    if (mnemonic === 'rigstate') {
        return `Rig State = ${originalValue} (${comparatorRaw}: [${originalThreshold}])`
    }

    const unitSetChannel = unitSet[mnemonic]
    const standardChannel = curves[mnemonic]

    const channel = curves[mnemonic]?.description || mnemonic
    const comparator =
        comparatorRaw === 'in range' ? 'between' : comparatorRaw === 'outside range' ? 'not between' : comparatorRaw

    const convertedValuesExist =
        (convertedValue || convertedValue === 0) &&
        (convertedThreshold ||
            convertedThreshold === 0 ||
            (Array.isArray(convertedRangeThreshold) && convertedRangeThreshold.length === 2))
    const valueRaw = convertedValuesExist ? convertedValue : originalValue
    const value = formatNumber(valueRaw, unitSetChannel, standardChannel, convertedValuesExist)

    let thresholdRaw = originalThreshold
    if (convertedValuesExist) {
        if (Array.isArray(convertedRangeThreshold) && convertedRangeThreshold.length === 2) {
            thresholdRaw = convertedRangeThreshold
        } else {
            thresholdRaw = convertedThreshold
        }
    } else {
        if (Array.isArray(originalRangeThreshold) && originalRangeThreshold.length === 2) {
            thresholdRaw = originalRangeThreshold
        } else {
            thresholdRaw = originalThreshold
        }
    }

    const uom = !convertedValuesExist || typeof convertedUom === 'undefined' ? originalUom : convertedUom

    const threshold = (Array.isArray(thresholdRaw) ? thresholdRaw : [thresholdRaw])
        .map(val => formatNumber(val, unitSetChannel, standardChannel, convertedValuesExist) + ' ' + uom)
        .join(' and ')

    return `${channel} = ${value} ${uom} (${comparator} ${threshold})`
}

const AlarmCardText = ({ alarm, selectedUnitSetCurves, curves }) => {
    const channel = alarm.trigger.channel
    const unitSetChannel = selectedUnitSetCurves[channel]
    const standardChannel = curves[channel]
    const unit = (unitSetChannel && unitSetChannel.unit) || (standardChannel && standardChannel.unit)

    const {
        comparator: comparatorRaw = alarm.parsedComparator,
        threshold: originalThreshold = alarm.parsedThreshold,
        conditions: originalConditions
    } = alarm.trigger.alarm
    const { value: convertedValue, threshold: convertedThreshold } = alarm.converted || {}
    const conditions = alarm.convertedConditions

    const oldFormatCondition = {
        channel: alarm.ref.mnemonic,
        comparator: comparatorRaw,
        threshold: convertedThreshold,
        value: convertedValue,
        uom: unit
    }
    const oldFormatOriginalCondition = {
        channel: alarm.ref.mnemonic,
        comparator: comparatorRaw,
        threshold: originalThreshold,
        value: alarm.trigger.value,
        uom: unit
    }

    return (
        <div>
            {(originalConditions || [oldFormatOriginalCondition]).map((cond, idx) => (
                <div key={idx}>
                    {formatCondition(
                        originalConditions ? (conditions ? conditions[idx] || {} : cond) : oldFormatCondition,
                        cond,
                        selectedUnitSetCurves,
                        curves
                    )}
                </div>
            ))}
        </div>
    )
}

export default AlarmCardText
